module.exports = __webpack_public_path__ + "img/online_updates.5e2e6f9f.svg";